<template>
    <v-card v-if="session && parameters">
        <v-card-text>
            <v-expansion-panels focusable multiple>
                <v-expansion-panel v-for="service in Object.values(parameters).sort((a, b) => (a.name > b.name) ? 1 : -1)">
                    <v-expansion-panel-header>
                        <span class="d-flex align-center justify-space-between">
                            <span v-text="service.name"></span>
                            <span>
                                <v-btn color="secondary" icon>
                                    <v-icon @click.prevent.stop="openRenameDialog(service)">mdi-pencil-outline</v-icon>
                                </v-btn>
                                <v-btn color="primary" icon>
                                    <v-icon>mdi-cog-outline</v-icon>
                                </v-btn>
                                <v-btn color="error" icon>
                                    <v-icon @click.prevent.stop="deleteService(service)">mdi-delete-outline</v-icon>
                                </v-btn>
                            </span>
                        </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row class="pl-5">
                            <v-col cols="12" md="6" lg="3">
                                <v-select class="mb-5" :items="icons" item-value="index" v-model="service.icon" label="Icone">
                                    <template slot="item" slot-scope="data">
                                        <div class="py-5 d-flex align-center justify-center">
                                            <v-img contain height="150px" width="150px" :src="require(`@/assets/images/icons/services/${data.item.file}`)"></v-img>
                                        </div>
                                    </template>
                                    <template slot="selection" slot-scope="data">
                                        <div class="py-5 d-flex align-center justify-center">
                                            <v-img contain height="150px" width="150px" :src="require(`@/assets/images/icons/services/${data.item.file}`)"></v-img>
                                        </div>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="6" lg="9">
                                <v-row>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field type="number" label="Part d'achat" suffix="%" v-model="service.purchaseShare"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field type="number" label="Prix min" suffix="€" v-model="service.minimalPrice"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field type="number" label="Prix max" suffix="€" v-model="service.maximalPrice"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field type="number" label="Taux de report" suffix="%" v-model="service.carryoverRate"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field type="number" label="Temps de production" suffix="heure(s)" v-model="service.productionTime"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field type="number" label="Coûts de production" suffix="€" v-model="service.productionCost"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field type="number" label="Frais de distribution" suffix="%" v-model="service.distributionCost"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field type="number" label="Coûts de R&D" suffix="%" v-model="service.rndCost"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-row class="d-flex align-center justify-center">
                <v-col cols="8" class="pa-3 d-flex align-center justify-center">
                    <v-select :items="services" return-object item-text="name" v-model="selectedService" label="Service"></v-select>
                    <v-btn color="primary" outlined class="ml-3" @click="addService">
                        <v-icon>mdi-plus</v-icon>
                        <b>Ajouter le service</b>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-dialog v-model="serviceRenameDialog" scrollable persistent max-width="500px">
            <v-card>
                <v-card-title class="headline">Renommer le service</v-card-title>
                <v-card-text>
                    <v-text-field label="Nom de le service" v-model="serviceRenameName"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="serviceRenameDialog = false">Annuler</v-btn>
                    <v-btn color="primary" text @click="renameService">Renommer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { v4 as uuidv4 } from 'uuid'

import assetsIcons from '@/config/assetsIcons';

import Service from "@/classes/Service";

export default {
    name: "ServicesParametersTab",
    props: ["session"],
    data() {
        return {
            unsub: [],
            parameters : this.session.servicesConfig,
            services : [],
            selectedService : null,
            serviceRenameDialog : false,
            serviceRenameSelected : null,
            serviceRenameName : null,
            icons: assetsIcons.services
        }
    },
    created() {
        this.unsub.push(Service.listenAll((services) => {
            this.services = services
            this.services.sort((a, b) => (a.name > b.name) ? 1 : -1)
        }))
    },
    methods: {
        addService() {
            if (this.selectedService) {
                let newService = {...this.selectedService}
                newService.uuid = uuidv4()
                this.parameters[newService.uuid] = newService
                this.selectedService = null
                this.$emit('shapeChange')
            }
        },
        openRenameDialog(service) {
            this.serviceRenameSelected = service
            this.serviceRenameName = service.name
            this.serviceRenameDialog = true
        },
        renameService() {
            this.serviceRenameSelected.name = this.serviceRenameName
            this.serviceRenameDialog = false
        },
        deleteService(service) {
            Swal.fire({
                title: 'Etes vous sûr ?',
                text: 'Voulez vous vraiment supprimer ce service ?',
                icon: 'question',
                confirmButtonText: 'Confirmer',
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    delete this.parameters[service.uuid]
                    this.$forceUpdate()
                    this.$emit('shapeChange')
                }
            })
        }
    },
    destroyed() {
        this.unsub.forEach((unsub) => {
            if(typeof unsub == "function"){
                unsub()
            }
        })
    },
}
</script>